export { Middlewares } from "./app-router/middlewares";
export { RouterHooks } from "./app-router/hooks";
export { PanelNotifications } from "./app-notifications/notifications";
export { default as ValidationDict } from "./app-validation/vee-validate";
export { default as AxiosClient } from "./http-client/axios";

export { default as variablesService } from "./common/variablesService";
